import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import translates from '../how-we-calculate-score-i18n';

const classes = new Bem('blockAnalysisRegisterCourtDecisions');

@I18nHoc(translates())
export default class AnalysisRegisterCourtDecisionsBlock extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { i18n } = this;
    const { className } = this.props;

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'block')} mtColumn mpColumn>
          <Col {...classes('col', 'info')} allPr={0}>
            <div {...classes('text', 'h2')}><h2 children={i18n('analysisRegisterCourtDecisionsH2')} /></div>
            <Trans lang="ru">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Каждый отчёт содержит подробный анализ реестра судебных решений. Вы увидите прошлую и текущую судебную ситуацию вокруг объекта строительства." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Эксперт не просто приводит ссылки на решения, а описывает проблематику, хронологию и состояние дел." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Мы учитываем решения суда, постановления, приговоры, судебные приказы." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Мы анализируем суды с инвесторами, ГАСИ, департаментом градостроительства и архитектуры, прокуратурой, СБУ, НАБУ, ГБР." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text')} children="Анализ реестра судебных решений не влияет на балл Индекса надёжности и приводится в отчёте в информационном формате." />
                  </div>
                </li>
              </ul>
            </Trans>
            <Trans lang="ua">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Кожен звіт містить детальний аналіз реєстру судових рішень. Ви побачите минулу та поточну судову ситуацію навколо об'єкта будівництва." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Експерт не просто надає посилання на рішення, а описує проблематику, хронологію і стан справ." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Ми враховуємо рішення суду, постанови, вироки, судові накази." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Ми аналізуємо суди з інвесторами, ДАБІ, департаментом містобудування та архітектури, прокуратурою, СБУ, НАБУ, ДБР." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text')} children="Аналіз реєстру судових рішень не впливає на бал Індексу надійності і надється у звіті в інформаційному форматі." />
                  </div>
                </li>
              </ul>
            </Trans>
          </Col>
          <Col {...classes('col', 'img')} allPr={0}>
            <div {...classes('imgContainer')}>
              <img {...classes('img')} src={i18n('imgPDF3a')} alt={i18n('analysisRegisterCourtDecisionsH2')} loading="lazy" decoding="async" />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
